import { GridColDef } from '@mui/x-data-grid';

import DataGridBlankLabel from '../../../shared/components/ui/datagrid/datagrid-blank-label';

export const hrbpcolumns: GridColDef[] = [
  {
    field: 'signatory',
    headerName: 'Signatory',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.signatory);
    },
  },
  {
    field: 'signatory_email',
    headerName: 'Email',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.signatory_email);
    },
  },
  {
    field: 'department',
    headerName: 'Department',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.department);
    },
  },
  {
    field: 'position',
    headerName: 'Position',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.position);
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.status);
    },
  },
  {
    field: 'approved_at',
    headerName: 'Approved At',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.approved_at);
    },
  },
  {
    field: 'day_processed',
    headerName: 'No. of days proccess',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.day_processed);
    },
  },
  {
    field: 'remarks',
    headerName: 'Remarks',
    flex: 1,
    disableColumnMenu: true,
    renderCell: (e): any => {
      return DataGridBlankLabel(e.row.remarks);
    },
  },
];
